/* @jsx m */
import m from 'mithril';
import * as Story from '../js/story.js';
import Passage from './Passage.jsx';
import Choice from './Choice.jsx';
import ScrollBanner from './ScrollBanner.jsx';
import AppHeader from '../components/AppHeader.jsx';
import StatusBar from '../components/StatusBar.jsx';

export default class GameContainer {
    constructor() {
      this.data = null;
      this.handleStory(Story.init());
      this.showScrollBanner = false;
    }

    makeChoice(ind) {
      this.handleStory(Story.makeChoice(ind));
    }

    handleStory(dataRef) {
      this.data = dataRef;
    }

    onupdate(vnode) {
      if(!vnode.dom) return;
      this.showScrollBanner = !( (vnode.dom.scrollHeight - vnode.dom.scrollTop) - vnode.dom.clientHeight < 25);
    }

    onscroll() {
      //we actually don't need to do anything, just add this event to force updates
    }

    view() {
      return (
        <>
        <StatusBar time={this.data.time} />
        <AppHeader title={this.data.title}></AppHeader>
        <div id="story" class="" onscroll={this.onscroll}>
          <ScrollBanner show={this.showScrollBanner}/>
          {
            this.data.passages.map( (passage, index) => {
              if (!passage.text.length) return;
              return <Passage direction={passage.direction || 'sent'} visible={passage.visible}>{passage.text}</Passage>
            } )
          }
          <div className="choice-container">
          {
            this.data.choiceBlock.choices.map( (choice, index) => {
              return <Choice visible={this.data.choiceBlock.visible} styles={this.data.choiceBlock.styles} handler={this.makeChoice.bind(this)} choiceIndex={choice.index} key={choice.text}>{choice.text}</Choice>
            } )
          }
          </div>
        </div>
        </>
      );
    }
}
